const routerConst = {
  login: {
    path: '/login',
    searchPh: '',
    title: '',
    hasBack: false
  },

  forget: {
    path: '/forget',
    searchPh: '',
    title: '找回密码',
    hasBack: true
  },

  agreement: {
    path: '/agreement',
    searchPh: '',
    title: '服务条款',
    hasBack: true
  },

  tagManage: {
    path: '/tagManage',
    searchPh: '',
    title: '频道管理',
    hasBack: true
  },

  discover: {
    path: '/discover',
    searchPh: '搜点什么呢 ...',
    title: '',
    hasBack: false
  },

  data: {
    path: '/data',
    searchPh: '搜点什么呢 ...',
    title: '',
    hasBack: false
  },
  dataDetail: {
    path: '/dataDetail',
    searchPh: '',
    title: '',
    hasBack: true
  },

  filtered: {
    path: '/filtered',
    searchPh: '',
    title: function(title) {
      return title || '';
    },
    hasBack: true
  },

  search: {
    path: '/search',
    searchPh: '',
    title: '搜索结果',
    hasBack: true
  },

  digital: {
    path: '/digital',
    searchPh: '搜索数据报告',
    title: '',
    hasBack: false
  },

  digitalGeneral: {
    path: '/digitalGeneral',
    searchPh: '',
    title: function(title) {
      return title || '';
    },
    hasBack: true
  },

  digitalDetail: {
    path: '/digitalDetail',
    searchPh: '',
    title: '',
    hasBack: true
  },

  vip: {
    path: '/vip',
    searchPh: '',
    title: '友绿VIP',
    hasBack: false
  },

  userCenter: {
    path: '/userCenter',
    searchPh: '',
    title: '个人主页',
    hasBack: true
  },

  college: {
    path: '/college',
    searchPh: '搜索课程',
    title: '',
    hasBack: false
  },

  courseDetail: {
    path: '/courseDetail',
    searchPh: '',
    title: function(title) {
      return title || '';
    },
    hasBack: true
  },

  pdfViewer: {
    path: '/pdfViewer',
    searchPh: '',
    title: function(title) {
      return title || '';
    },
    hasBack: true
  },

  news: {
    path: '/news',
    searchPh: '搜点什么呢 ...',
    title: '搜索资讯文章',
    hasBack: true
  },

  newsDetail: {
    path: '/newsDetail',
    searchPh: '',
    title: '',
    hasBack: true
  },

  open: {
    path: '/open',
    searchPh: '',
    title: '开通VIP',
    hasBack: true,
    theme: 'dark'
  },

  about: {
    path: '/about',
    searchPh: '',
    title: '关于我们',
    hasBack: true
  },

  my: {
    path: '/my',
    searchPh: '',
    title: '会员中心',
    hasBack: false,
    noLogo: true
  },

  feedback: {
    path: '/my/feedback',
    searchPh: '',
    title: '意见反馈',
    hasBack: true
  },

  setting: {
    path: '/my/setting',
    searchPh: '',
    title: '安全设置',
    hasBack: true
  },

  message: {
    path: '/my/message',
    searchPh: '',
    title: '通知',
    hasBack: true
  },

  wallet: {
    path: '/my/wallet',
    searchPh: '',
    title: '钱包',
    hasBack: true
  },

  history: {
    path: '/my/history',
    searchPh: '',
    title: '最近阅读',
    hasBack: true
  },

  transaction: {
    path: '/my/transaction',
    searchPh: '',
    title: '历史纪录',
    hasBack: true
  },

  order: {
    path: '/my/order',
    searchPh: '',
    title: '我的订单',
    hasBack: true
  },



  achievement: {
    path: '/my/achievement',
    searchPh: '',
    title: '达成成就',
    hasBack: true
  },
  learning: {
    path: '/my/learning',
    searchPh: '',
    title: '学习成就',
    hasBack: true
  },
  favorite: {
    path: '/my/favorite',
    searchPh: '',
    title: '我的收藏',
    hasBack: true
  },

  edit: {
    path: '/my/edit',
    searchPh: '',
    title: '编辑资料',
    hasBack: true
  },

  changePass: {
    path: '/my/changePass',
    searchPh: '',
    title: '修改密码',
    hasBack: true
  },

  following: {
    path: '/my/following',
    searchPh: '',
    title: '我的关注',
    hasBack: true
  },
  share: {
    path: '/share',
    searchPh: '',
    title: '邀请好友',
    hasBack: true
  },
  privacyPolicy:{
    path: '/my/privacyPolicy',
    searchPh: '',
    title: '隐私政策',
    hasBack: true
  }
};

export default routerConst;
